var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-tooltip',{attrs:{"bottom":""},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
var on = ref.on;
var attrs = ref.attrs;
return [_c('v-btn',_vm._g(_vm._b({staticClass:"ma-0 btn-tools",attrs:{"text":"","icon":"","color":"black","disabled":_vm.isDisabled},on:{"click":_vm.event}},'v-btn',attrs,false),on),[_c('v-icon',[_vm._v(" "+_vm._s(_vm.icon)+" ")])],1)]}}])},[_c('span',[_vm._v(" "+_vm._s(_vm.desctiption)+" ")])])}
var staticRenderFns = []

export { render, staticRenderFns }